module.exports = __webpack_public_path__ + "000bc3c1d4f419966613e3198890c934.svg";